import React from 'react';

import { Spinner } from '@flixbus/honeycomb-react';

import styles from './styles.module.css';

const Loader = () => (
	<div className={styles.loader} data-testid="loader" role="status" aria-label="Loading">
		<Spinner />
	</div>
);

export default Loader;
